import { render, staticRenderFns } from "./UserDash.vue?vue&type=template&id=6a9e6533&scoped=true&"
import script from "./UserDash.vue?vue&type=script&lang=js&"
export * from "./UserDash.vue?vue&type=script&lang=js&"
import style0 from "./UserDash.vue?vue&type=style&index=0&id=6a9e6533&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9e6533",
  null
  
)

export default component.exports